import { useEffect, useState } from "react";
import { Form, Field } from "formik";
import { Button, Col, FormGroup, InputGroup, InputGroupText, Label, Row } from "reactstrap";
import styles from "./MasterForm.module.scss";
import Loader from "../common/Loader/Loader";
import { BiRupee } from "react-icons/bi";
import { capitalizeFirstLetter, OnlyNumberAllow, OnlyNumberLength } from "../../helpers";
import MultiSelect from "../common/Form/Multiselect";
import { useSelector } from "react-redux";

const UpdateMasterForm = (props) => {
    const { errors, touched } = props;
    const [departmentOption, setDepartmentOption] = useState([])
    const departmentment = useSelector((state) => state.masterData.department);

    useEffect(() => {
        if (departmentment && departmentment.length > 0) {
            const resVal = departmentment.map((val) => {
                return {
                    id: val?.id,
                    value: val?.id,
                    label: val?.name,
                    isDisabled: true
                };
            });
            setDepartmentOption(resVal);
        }
    }, [departmentment]);

    return (
        <Form className={`${styles.MasterForm}`}>

            <FormGroup className="form-group">
                <Label className={styles.formLabel}>Type</Label>
                <Field
                    name="type"
                    id="type"
                    className="form-control"
                    style={{textTransform:'capitalize'}}
                    disabled
                />
                {errors.type || touched.type ? (
                    <div className={styles.formError}>{errors.type}</div>
                ) : null}
            </FormGroup>
            {props?.editedData && props?.editedData?.type === "designation" ?
                <FormGroup className="form-group">
                    <Label className={styles.formLabel}>Department</Label>
                    <Field
                        name="parentId"
                        id="parentId"
                        placeholder="Select Department"
                        isMulti={false}
                        component={MultiSelect}
                        options={departmentOption}
                        autocomplete="off"
                        disabled={true}
                    />

                </FormGroup>

                : ""}


            <FormGroup className="form-group">
                <Label className={styles.formLabel}> {capitalizeFirstLetter(props?.editedData?.type)}</Label>
                <Field
                    name="name"
                    id="name"
                    className="form-control"
                    maxlength="30"
                    pattern="^[^,]*$"
                    title="Comma is not allowed."
                    required
                />
                {errors.name || touched.name ? (
                    <div className={styles.formError}>{errors.name}</div>
                ) : null}
            </FormGroup>
            {props?.editedData && props?.editedData?.type === "designation" ?
                <>
                    <FormGroup className="form-group">
                        <Label className={styles.formLabel}>CTC</Label>
                        <Row>
                            <Col md={6}>
                                <InputGroup>
                                    <InputGroupText>
                                        <BiRupee />{" "}
                                    </InputGroupText>
                                    <Field
                                        className="form-control"
                                        onKeyPress={(event) => {
                                            OnlyNumberLength(event);
                                        }}
                                        maxlength="8"
                                        placeholder="Min."
                                        name={`min_salary`}
                                        autocomplete="off" />
                                </InputGroup>
                            </Col>
                            <Col md={6}>
                                <InputGroup>
                                    <InputGroupText>
                                        <BiRupee />{" "}
                                    </InputGroupText>
                                    <Field
                                        className="form-control"
                                        onKeyPress={(event) => {
                                            OnlyNumberLength(event);
                                        }}
                                        maxlength="8"
                                        placeholder="Max."
                                        name={`max_salary`}
                                        autocomplete="off" />
                                </InputGroup>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup className="form-group">
                        <Label className={styles.formLabel}>Description</Label>
                        <Field
                            as="textarea"
                            className="form-control"
                            name={`description`}
                            autocomplete="off" 
                            maxlength="200"
                            />
                    </FormGroup>
                </> : ""}

            <Button type="submit" className={styles.brandButton}>
                {props?.loderPart ? (
                    <Loader height={30} width={30} color={"#FFFFFF"} />
                ) : (
                    "Update"
                )}
            </Button>
        </Form>
    );
};

export default UpdateMasterForm;
